import React, { Component } from 'react';
import * as Styles from './Styles';
import SvgArrowDown2 from '../../../others/svg_dist/ArrowDown2';

type Props = {
	heading: string;
	content: string[];
	accent: string;
	no: number;
};

type State = {
	extended: boolean;
};

class Tab extends Component<Props, State> {
	state: State = {
		extended: false,
	};

	mapText = (text: string) => {
		const key = text;
		switch (text.charAt(0)) {
			case '*':
				return (
					<Styles.TabContentFont key={key} className="dot">
						{text.slice(1)}
					</Styles.TabContentFont>
				);
			case '#':
				return (
					<Styles.TabContentFont key={key} className="bold">
						{text.slice(1)}
					</Styles.TabContentFont>
				);
			default:
				return (
					<Styles.TabContentFont key={key}>
						{text}
					</Styles.TabContentFont>
				);
		}
	};

	render() {
		return (
			<Styles.TabWrapper
				extended={this.state.extended}
				onClick={() =>
					this.setState({
						...this.state,
						extended: !this.state.extended,
					})
				}
				accent={this.props.accent}
			>
				<Styles.TabTitleFont>
					<span>{this.props.no}.</span>
					{this.props.heading}
				</Styles.TabTitleFont>
				<SvgArrowDown2 />
				<Styles.TabContentContainer extended={this.state.extended}>
					{this.props.content.map((el) => this.mapText(el))}
				</Styles.TabContentContainer>
			</Styles.TabWrapper>
		);
	}
}

export default Tab;
